import React, { Component } from 'react';
import AppRoutes from '../../../config/AppRoutes';
/* eslint-disable */

import App_data from '../../../config/App_data';
import FD from '../../../RestAPI/fetchData';
import language from '../../../../assets/languages/language';
import StarRatings from 'react-star-ratings';
import ValidateSaveReportIcon from '../../../Common/ValidateSaveReportIcon';
import Loader from '../../../../common/loader';
import GMATCalculator from '../../../../common/Calculator/GMATCalculator';
import { renderHTMLContent } from '../../../../common/function';
var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
class GMATGraphical extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      question: '',
      answers: {},
      token: '',
      idname: '',
      save_text: `${language.LC().SAVE_QUESTION}`,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      reportLoading: false,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      all_questions: '',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      text_color: 'card-header',
      result: '',
      explanation: '',
      questionsArray: [],
      chapter_id: this.props.params.chapterid,
      reading_id: this.props.params.readingid,
      subscriptionstatus: parseInt(this.props.params.subscription, 10) ? 'paid' : 'free',
      reading: this.props.params.reading,
      offset: this.props.params.offset,
      display_loader: 'show_block',
      questionHide: 'hide_block',
    };
  }
  componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      reading_id: this.props.params.readingid,
      question_type: 'graph_question',
      subscriptionstatus: parseInt(this.props.params.subscription, 10) ? 'paid' : 'free',
    };
    FD.callAPI(
      App_data.backend_api + '/gmat_question_bank/getSpecialQuestionByReadingId',
      data,
    ).then(async resp => {
      if (resp.success) {
        let { offset } = this.state;
        this.setState({
          questionsArray: resp.result,
        });
        this.setQuestionData(resp.result, offset);
      }
    });
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  clickHandler = (e, statement) => {
    const { value } = e.target;
    this.setState({
      [statement]: { value, index: e.target.options.selectedIndex },
    });
  };
  //Function to fetch previous question
  _getPrevious = () => {
    this.setState({
      display_loader: 'show_block',
      validated: false,
      rated: false,
      rating: 0,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      save_text: `${language.LC().SAVE_QUESTION}`,
      timerstopbtn: 'pause_btn icon-control-pause',
      report_block: 'card hide_block',
      choice_name: '',
      bookmarkColor: '',
    });
    document.getElementById('comment').value = '';
    let offset = parseFloat(this.state.offset) - 1;
    const { questionsArray, reading } = this.state;
    this.setQuestionData(questionsArray, offset);
    this.context.router.push({
      pathname: AppRoutes.GMAT_GRAPH_MULTI_STATEMENT.replace(':chapterid', this.state.chapter_id)
        .replace(':readingid', this.state.reading_id)
        .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
        .replace(':question_id', questionsArray[offset || 0].id)
        .replace(':offset', offset)
        .replace(':reading', reading),
    });
  };

  //Function to fetch Next question
  _getNext = () => {
    this.setState({
      display_loader: 'show_block',
      validated: false,
      rated: false,
      rating: 0,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      save_text: `${language.LC().SAVE_QUESTION}`,
      timerstopbtn: 'pause_btn icon-control-pause',
      report_block: 'card hide_block',
      choice_name: '',
      bookmarkColor: '',
    });
    document.getElementById('comment').value = '';
    let offset = parseFloat(this.state.offset) + 1;
    const { questionsArray, reading } = this.state;
    this.setQuestionData(questionsArray, offset);
    this.context.router.push({
      pathname: AppRoutes.GMAT_GRAPH_MULTI_STATEMENT.replace(':chapterid', this.state.chapter_id)
        .replace(':readingid', this.state.reading_id)
        .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
        .replace(':question_id', questionsArray[offset || 0].id)
        .replace(':offset', offset)
        .replace(':reading', reading),
    });
  };

  setQuestionData = (questionsArray, offset) => {
    let questionObj = questionsArray[offset || 0];
    if (questionObj) {
      this.setState(
        {
          statement1: questionObj.statement1,
          statement2: questionObj.statement2,
          question: questionObj.question,
          questionId: questionObj.id,
          explanation: questionObj.explanation,
          questionObj,
          offset,
          // display_loader: 'hide_block',
          questionHide: '',
          answers1: questionObj.answer_statement1,
          answers2: questionObj.answer_statement2,
          result_block: 'card hide_block',
          report_block: 'card hide_block',
          statementSelect1: '',
          statementSelect2: '',
        },
        () => {
          this.getFavQuestions(questionObj.id);
          this.getGMATRatting(questionObj.id);
        },
      );
    }
  };

  getFavQuestions = questionid => {
    var params_fav = {
      token: this.state.token,
      question_id: questionid,
      idname: this.state.idname,
      chapter_id: this.props.params.chapterid,
      type: 'graph_question',
    };
    console.log('I am inside get Fav question', questionid);
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params_fav).then(
      response => {
        if (response.success) {
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
          });
        }
      },
    );
  };

  getGMATRatting = questionid => {
    var params = {
      token: this.state.token,
      question_id: questionid,
      idname: this.state.idname,
      type: 'graph_question',
    };
    //Api to get ratting
    console.log('I am inside get Fav question', questionid);
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getGMATRatting', params).then(
      response => {
        if (response.success) {
          this.setState({ rated: true });
          response.ratting.map(items =>
            this.setState({
              rating: items.ratting,
              ratting_text: 'Rated ',
            }),
          );
        }
      },
    );
  };
  //Function to redirect page to readings page
  _getReadings = () => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUESTION_BANK_READING.replace(':id', this.props.params.chapterid),
    });
  };

  _getQuestions = () => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUESTION_BANK_LIST_QUE.replace(
        ':chapter_no',
        this.props.params.chapterid,
      )
        .replace(':id', this.props.params.readingid)
        .replace(':subscriptionstatus', this.state.subscriptionstatus)
        .replace(':reading', this.state.reading),
    });
  };

  //Function to show calculator
  _handleModal = () => {
    this.setState({
      show: true,
    });
  };

  //Function to show Correct box and display right answer and store in database
  _getResult = async (item, e) => {
    let { statementSelect1, statementSelect2, answers2, answers1, questionObj } = this.state;
    const boundaryConditionAnswer1 = questionObj[`statement1_option${statementSelect1.index}`]
      .toLowerCase()
      .trim();
    const boundaryConditionAnswer2 = questionObj[`statement2_option${statementSelect2.index}`]
      .toLowerCase()
      .trim();
    statementSelect2 = statementSelect2.value.toLowerCase().trim();
    answers2 = answers2.toLowerCase().trim();
    statementSelect1 = statementSelect1.value.toLowerCase().trim();
    answers1 = answers1.toLowerCase().trim();
    let count = 0;
    if (statementSelect1 && statementSelect2) {
      if (
        statementSelect2 === answers2 ||
        `&${statementSelect2}` === answers2 ||
        boundaryConditionAnswer2 === answers2
      ) {
        count++;
      }
      if (
        statementSelect1 === answers1 ||
        `&${statementSelect1}` === answers1 ||
        boundaryConditionAnswer1 === answers1
      ) {
        count++;
      }
      let right_answer = 0;
      if (count === 2) {
        right_answer = 1;
        this.setState({
          result: 'CORRECT',
          text_color: 'card-header text_success',
          result_block: 'card show_block',
        });
      } else {
        this.setState({
          result_block: 'card show_block',
          result: 'INCORRECT',
          text_color: 'card-header text_failure',
        });
      }
      // --------------- Save Stat API call Start -----------//
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        question_id: this.state.questionId,
        right_answer: right_answer,
        type: 'graph_question',
        // time_done: this.state.count,
      };

      await FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveStats', data).then(
        async resp => {
          if (resp.success) {
            this.setState({
              ValidToken: true,
              validated: true,
            });
          } else {
            this.setState({
              ValidToken: false,
            });
          }
          return resp;
        },
      );

      // --------------- Save Stat API call End-----------//
    }
  };
  //Function to Display Saved Question on button and save in database
  _saveQuestion = (item, e) => {
    // console.log("_saveQuestion");
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: this.state.questionId,
      type: 'graph_question',
      topic_name: this.state.reading,
      reading_id: this.props.params.readingid,
    };
    if (this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      // return;
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
            bookmarkColor: '',
            save_text: `${language.LC().SAVE_QUESTION}`,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    } else {
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveQuestion', data).then(resp => {
        if (resp.success) {
          this.setState({ ValidToken: true });
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          });
          this.setState({
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
          });
          this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
          this.setState({ save_text: `${language.LC().Question_Saved}` });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    }
  };
  //Function to show Report box
  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  //Function to give star rattings
  onStarClick(item, nextValue, prevValue, name) {
    if (prevValue !== nextValue) {
      let params = {
        token: this.state.token,
        idname: this.state.idname,
        question_id: this.state.questionId,
        ratting: nextValue,
        type: 'graph_question',
      };
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/UpdateGMATRatting', params).then(
        response => {
          if (response.success) {
            this.setState({ rated: 1 });
            this.setState({ ratting_text: 'Rated ' });
          }
        },
      );
    }
    this.setState({ rating: nextValue });
    let params = {
      token: this.state.token,
      question_id: this.state.question_id,
      idname: this.state.idname,
      type: 'graph_question',
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getGMATRatting', params).then(
      response => {
        if (response.success) {
          if (response.ratting.length > 0) {
            this.setState({ rated: true });
            response.ratting.map(items => {
              this.setState({ rating: items.ratting });
              this.setState({ ratting_text: `${language.LC().RATED}` });
            });
          } else {
            var params = {
              token: this.state.token,
              idname: this.state.idname,
              question_id: this.state.questionId,
              ratting: nextValue,
              type: 'graph_question',
            };
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(
              response => {
                if (response.success) {
                  this.setState({ rated: 1 });
                  this.setState({ ratting_text: `${language.LC().RATED}` });
                }
              },
            );
          }
        } else {
          let params = {
            token: this.state.token,
            idname: this.state.idname,
            question_id: item.id,
            ratting: nextValue,
          };
          FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(
            response => {
              if (response.success) {
                this.setState({ rated: 1 });
                this.setState({
                  ratting_text: `${language.LC().RATED}${nextValue} stars`,
                });
              }
            },
          );
        }
      },
    );
  }

  //Function to hide Report box
  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };

  //Funcion to save new report question
  _reportQuestion = (item, e) => {
    var comment = document.getElementById('comment').value;
    if (comment.length < 2) {
      return;
    }
    // const result = getDeviceDetails();
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: this.state.questionId,
      comment: comment,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
      type: 'graph_question',
      topic_name: this.state.reading,
      reading_id: this.props.params.readingid,
    };
    // console.log(data);
    this.setState({
      reportLoading: true,
    });
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/reportQuestion', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          successAlert: true,
          reportLoading: false,
        });
        document.getElementById('comment') ? (document.getElementById('comment').value = '') : '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };
  onClose = e => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };
  handleImageLoaded() {
    console.log('I am inside handleImageLoaded');
    this.setState({
      imageStatus: 'loaded',
      display_loader: 'hide_block',
    });
  }

  handleImageErrored() {
    console.log('I am inside handleImageErrored');
    this.setState({ imageStatus: 'failed to load' });
  }

  render() {
    const {
      question,
      all_questions,
      reportLoading,
      explanation,
      offset,
      questionsArray,
      reading,
      display_loader,
      questionHide,
      statement1,
      statement2,
      questionId,
    } = this.state;
    return (
      <div>
        {/* ---------- Header -------------------- */}
        <div className='margin_bottom_10 d-flex justify-content-between'>
          <div>
            <h1 className='section_head'>{language.LC().QUESTION_BANK}</h1>
          </div>
          <div>
            <button
              type='button'
              className='btn btn-primary pointer_class calc-btn'
              onClick={this._handleModal}
            >
              {language.LC().OPEN_CALCULATOR}
            </button>
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getQuestions}
            >
              {language.LC().CHANGE_QUESTIONS}
            </button>

            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getReadings}
            >
              {language.LC().CHANGE_READING}
            </button>
          </div>
        </div>
        {/* ----------- Question ------------------- */}
        <div className={`card margin_bottom_40 ${questionHide}`}>
          <div className='card-header'>
            <img
              src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
              className='margin_right_20'
              width='30'
              alt=''
            />
            {renderHTMLContent(reading, "span", "", { contentEditable: 'false' })}
            (
            {language.LC().Q} {questionId})
            <div className='float-right text-right'>
              {parseInt(offset) !== 0 ? (
                <i
                  className={'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block}
                  onClick={this._getPrevious}
                />
              ) : null}
              {questionsArray.length - 1 !== parseInt(offset) ? (
                <i
                  className={'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block}
                  onClick={this._getNext}
                />
              ) : null}
            </div>
          </div>
          <div className='card-block font-16px'>
            <div className='margin_bottom_30 statement-question-div'>
              {renderHTMLContent(question ? question.split('<img src="')[0] : '', "div")}
              <img
                src={question ? question.split('<img src="')[1].split('"')[0] : ''}
                onLoad={this.handleImageLoaded.bind(this)}
                onError={this.handleImageErrored.bind(this)}
              />
              {renderHTMLContent(question ? question.split('<img src="')[1].split('/>')[1] : '', "div")}
              {renderHTMLContent(statement1, "div", "my-1", { onClick: e => this.clickHandler(e, 'statementSelect1') })}
              {renderHTMLContent(statement2, "div", "", { onClick: e => this.clickHandler(e, 'statementSelect2') })}
            </div>
            {/* --------- Validate Icon -----------*/}
            <div className='row bottom-tool'>
              <ValidateSaveReportIcon
                isQue={true}
                _getResult={this._getResult}
                _saveQuestion={this._saveQuestion}
                _displayReportForm={this._displayReportForm}
                all_questions={question}
                save_text={this.state.save_text}
                bookmarkCSS={this.state.bookmarkCSS}
                bookmarkColor={this.state.bookmarkColor}
              // isSpecialQuestion={true}
              />
              <div className='col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right'>
                <div className='star_rating_wrap'>
                  <span className=' margin_bottom_0 margin_right_10'>
                    {this.state.ratting_text}
                  </span>
                  <StarRatings
                    rating={this.state.rating}
                    starRatedColor='rgb(255, 180, 0)'
                    starEmptyColor='rgb(51, 51, 51)'
                    starDimension='20px'
                    starHoverColor='rgb(255, 180, 0)'
                    starSpacing='2px'
                    changeRating={this.onStarClick.bind(this, question)}
                    numberOfStars={5}
                    name='rate1'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* --------- Explanation popup -------*/}
        <div className={`${this.state.result_block} font-lusitana font-16px`}>
          <div className={this.state.text_color}>{this.state.result}</div>
          <div className='card-block'>
            {renderHTMLContent(
              explanation,
              "p",
              "view_questionhtml",
              { contentEditable: 'false' }
            )}
          </div>
        </div>
        {/* ------- Report Question ---------------- */}
        <div className={this.state.report_block}>
          <div className='card-header'>{language.LC().REPORT}</div>

          {!this.state.successAlert ? (
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-12'>
                  <label className='form-control-label' htmlFor='textarea-input'>
                    <strong> {language.LC().COMMENT}</strong>
                  </label>
                </div>
                <div className='col-sm-12 margin_bottom_10'>
                  <textarea
                    id='comment'
                    name='comment'
                    rows='6'
                    className='form-control'
                    placeholder='Content..'
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12'>
                  <button
                    type='button'
                    className='btn btn-primary active pointer_class report-btn'
                    disabled={reportLoading}
                    onClick={this._reportQuestion.bind(this, all_questions)}
                  >
                    {' '}
                    {reportLoading ? language.LC().PLEASE_WAIT : language.LC().REPORT}
                  </button>
                  <button
                    type='button'
                    className='btn btn-danger active pointer_class margin_left_10'
                    onClick={this._hideReportForm.bind(this, all_questions)}
                  >
                    {' '}
                    {language.LC().CANCEL}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-12 report-Success-card'>
                  <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                  <label className='form-control-label' htmlFor='textarea-input'>
                    <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                  </label>
                  <button
                    type='button'
                    className='btn btn-primary active pointer_class  min-vw-120'
                    onClick={this.onClose}
                  >
                    {' '}
                    {language.LC().CLOSE}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* ---------- Loader ---------------- */}
        {display_loader === 'show_block' ? <Loader /> : null}
        <GMATCalculator
          addToInput={this.addToInput}
          show={this.state.show}
          addDecimal={this.addDecimal}
          addZeroToInput={this.addZeroToInput}
          clearInput={this.clearInput}
          add={this.add}
          subtract={this.subtract}
          multiply={this.multiply}
          divide={this.divide}
          evaluate={this.evaluate}
          closeModal={() => this.setState({ show: false })}
        />
      </div>
    );
  }
}
export default GMATGraphical;



// WEBPACK FOOTER //
// ./src/views/GMAT/QuestionBank/SpecialQuestions/GMATMultipleStatement.js